import { render } from "./RegisterAccess.vue?vue&type=template&id=02cd420c"
import script from "./RegisterAccess.vue?vue&type=script&lang=js"
export * from "./RegisterAccess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__